import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  TimeScale,
  Tooltip,
  Legend
} from 'chart.js';
import 'chartjs-adapter-date-fns';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, TimeScale, Tooltip, Legend);

function GraficaSensor({ datos, tipo }) {
  const filtrados = datos.filter(d => d.Tipo.toLowerCase() === tipo.toLowerCase());

  const data = {
    labels: filtrados.map(d => new Date(d.FechaHora)),
    datasets: [
      {
        label: tipo,
        data: filtrados.map(d => d.Valor),
        borderColor: '#00c4b3',
        backgroundColor: 'rgba(0, 196, 179, 0.2)',
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: true },
      tooltip: { mode: 'index', intersect: false }
    },
    scales: {
      x: {
        type: 'time',
        time: { unit: 'minute' },
        title: { display: true, text: 'Hora' }
      },
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Valor' }
      }
    }
  };

  return <Line data={data} options={options} />;
}

export default GraficaSensor;
